import {
  AddSessionPageRequest,
  SessionPageCollection,
  SessionPageDetails,
  SessionPagePartialModel,
  UpdateSessionPageRequest
} from '../models/api';
import { deleteData, getData, patchData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const add = async (
  sessionReference: string,
  model: AddSessionPageRequest
): Promise<ResponseData<SessionPageDetails>> =>
  postData<SessionPageDetails>(
    `api/sessions/${sessionReference}/end/pages`,
    model
  );
export const remove = async (
  sessionReference: string,
  endPageReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/sessions/${sessionReference}/end/pages/${endPageReference}`);
export const updatePages = async (
  sessionReference: string,
  pages: SessionPagePartialModel[]
): Promise<ResponseData<SessionPageCollection>> =>
  patchData<SessionPageCollection>(
    `api/sessions/${sessionReference}/end/pages`,
    {
      pages: pages
    }
  );
export const update = async (
  sessionReference: string,
  endPageReference: string,
  model: UpdateSessionPageRequest
): Promise<ResponseData<SessionPageDetails>> =>
  putData<SessionPageDetails>(
    `api/sessions/${sessionReference}/end/pages/${endPageReference}`,
    model
  );
